module.exports = __webpack_public_path__ + "img/firstBanner.238627ab.png";